module.exports = __webpack_public_path__ + "static/media/AgencyLandingPage.df4fcdeb.jpeg";